import { render } from "./CreateDocModal.vue?vue&type=template&id=3d794b02&scoped=true"
import script from "./CreateDocModal.vue?vue&type=script&lang=js"
export * from "./CreateDocModal.vue?vue&type=script&lang=js"

import "./CreateDocModal.vue?vue&type=style&index=0&id=3d794b02&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d794b02"]])

export default __exports__